module.exports = __webpack_public_path__ + "img/icon_coordinates1.9e6db484.png";